/* eslint-disable no-unused-expressions */
import React, { useRef, useState } from 'react';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import classNames from 'classnames';

const FileInput = ({
  title,
  prependTitle,
  appendTitle,
  size,
  isValid,
  isInvalid,
  disabled,
  value,
  onChange,
  type,
  skin,
  onFocus,
  onBlur,
  className,
  errorText,
  ...rest
}) => {
  const input = useRef();
  const [hasFocus, setFocus] = useState(false);
  return (
    <div
      className={classNames(className, {
        focused: hasFocus,
        valid: isValid,
        invalid: isInvalid,
      })}
    >
      <InputGroup
        size={size}
        style={skin.InputGroup}
        onClick={() => input.current && input.current.focus()}
      >
        {title ? (
          <InputGroup.Prepend style={skin.Prepend}>
            <InputGroup.Text style={skin.PrependText}>{title}</InputGroup.Text>
          </InputGroup.Prepend>
        ) : null}
        {prependTitle ? (
          <InputGroup.Prepend style={skin.Prepend}>
            {prependTitle}
          </InputGroup.Prepend>
        ) : null}
        <FormControl
          ref={input}
          type="file"
          style={{
            height: 'auto',
            ...skin.Input,
            cursor: disabled ? 'not-allowed' : null,
          }}
          onChange={e => {
            if (!input.current) return;
            [...input.current.files].forEach(file => {
              const reader = new FileReader();
              e.persist();
              reader.onload = e => {
                if (e.target?.result !== undefined) {
                  e.target.name = file.name;
                  e.target.value = e.target?.result;
                  onChange(e);
                }
              };
              input.current.value = '';
              reader.readAsDataURL(file);
            });
          }}
          {...{
            ...rest,
            isValid,
            isInvalid,
            value,
            disabled,
            onFocus: () => {
              onFocus && onFocus();
              setFocus(true);
            },
            onBlur: () => {
              onBlur && onBlur();
              setFocus(false);
            },
          }}
        />
        {appendTitle ? (
          <InputGroup.Append style={skin.Append}>
            {appendTitle.substr ? (
              <InputGroup.Text style={skin.AppendText}>
                {appendTitle}
              </InputGroup.Text>
            ) : (
              appendTitle
            )}
          </InputGroup.Append>
        ) : null}
      </InputGroup>
      <FormControl.Feedback
        type="invalid"
        style={{ minHeight: '1em', display: 'block', marginBottom: '-1em' }}
      >
        {errorText || ''}
      </FormControl.Feedback>
    </div>
  );
};
export default FileInput;
